import React, { forwardRef } from 'react';
import Select from 'react-select';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';
import { useViewer } from 'src/hooks/use-viewer';
import { BasicHome } from '~static/svg-components';
import {
  contentHeaderPropertySelectComponents,
  useContentHeaderSelectStyles,
} from './content-header-property-select-props';
import ContentHeaderSelectReadOnly from './content-header-select-read-only';

const getOptionLabel = (option) => option?.name;
const getOptionValue = (option) => option?.id;

const Control = forwardRef((props, ref) => (
  <contentHeaderPropertySelectComponents.Control ref={ref} Icon={BasicHome} {...props} />
));

function PropertySelect(props) {
  const { readOnly, ...otherProps } = props;
  const {
    currentRole: {
      accessScope: { properties },
    },
  } = useViewer();
  const [{ currentViewProperty }] = useCurrentViewPropertySession();

  const styles = useContentHeaderSelectStyles();

  return readOnly ? (
    <ContentHeaderSelectReadOnly Icon={BasicHome} title={currentViewProperty.name} />
  ) : (
    <Select
      value={currentViewProperty}
      components={{ ...contentHeaderPropertySelectComponents, Control }}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      options={properties}
      styles={styles}
      {...otherProps}
    />
  );
}

export default PropertySelect;
